import { FilterItem } from '../filters';

export enum MediaPlacementType {
    FEDERAL = 'federal',
    REGIONAL = 'regional',
    LOCAL = 'local'
}

export const MEDIA_PLACEMENT_TYPE_MAP = {
  [MediaPlacementType.FEDERAL]: 'Федеральное',
  [MediaPlacementType.REGIONAL]: 'Региональное',
  [MediaPlacementType.LOCAL]: 'Городское'
};

export const MEDIA_PLACEMENT_TYPE_ARRAY: FilterItem<string>[] = Object.values(MediaPlacementType).map(el => ({ id: el, label: MEDIA_PLACEMENT_TYPE_MAP[el] }));
